<template>
  <TsMedia append-class="md:flex-row-revese bg-natural-soft-white p-4 rounded-lg h-full">
    <TsMediaStart>
      <NuxtLinkWithLocale :to="data.url">
        <div class="h-[114px] overflow-hidden">
          <TsImage
            :src="`${data.newsImage}?format=webp`"
            :alt="data.title"
            class="rounded-xl h-full"
            :width="isMobile ? '72' : '128'"
            :height="isMobile ? '72' : '115'"
            loading="lazy"
          />
        </div>
      </NuxtLinkWithLocale>
    </TsMediaStart>
    <TsMediaContent>
      <NuxtLinkWithLocale :to="data.url" class="flex flex-col h-full">
        <TsTypography
          append-class="max-md:mb-2 line-clamp-2 md:line-clamp-3"
          as="h4"
          dataTestid="blogs-news-and-advice-news-title"
          >{{ data.title }}
        </TsTypography>
        <TsTypography
          size="sm"
          append-class="mt-auto mb-0 flex items-center"
          dataTestid="blogs-news-and-advice-news-typography-hours"
        >
          {{ formatDate(data?.publishDate) }}
        </TsTypography>
      </NuxtLinkWithLocale>
    </TsMediaContent>
    <TsMediaEnd v-if="isMobile">
      <TsIcon
        size="32"
        class="h-full my-auto text-natural-grey"
        name="material-symbols-light:chevron-right"
        dataTestid="blogs-news-and-advice-news-icon"
      />
    </TsMediaEnd>
  </TsMedia>
</template>

<script setup lang="ts">
const { isMobile } = useDevice();

const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

const TsMediaEnd = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaEnd.vue')
);

type Data = {
  id: number;
  title: string;
  excerpt: string;
  url: string;
  newsImage: string;
  thumbnail: string;
};

type Props = {
  dataTestid: string;
  data: Data;
};

const props = withDefaults(defineProps<Props>(), {});
</script>
